module.exports = __webpack_public_path__ + "static/img/fbec_border_bg.01045c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/com/fbec_border_bg.png
// module id = KNbU
// module chunks = 27